import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { PageContextProvider } from '../utils/context/PageContext';

import 'reset-css';

const Layout = ({ children, pageContext, styles }) => {
  return (
    <PageContextProvider locale={pageContext.locale}>
      <Global
        styles={{
          body: {
            WebkitTextSizeAdjust: '100%',
            width: '100%',
            height: '100%',
            position: 'relative',
            ...styles
          },
          '*|*:link': {
            textDecoration: 'inherit',
            color: 'inherit'
          },
          '*': {
            WebkitFontSmoothing: 'antialiased',
            textRendering: 'optimizeLegibility',
            MozOsxFontSmoothing: 'grayscale'
          }
        }}
      />
      {children}
    </PageContextProvider>
  );
};

Layout.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string
  }),
  styles: PropTypes.object
};

Layout.defaultProps = {
  pageContext: {
    locale: 'en'
  },
  styles: {}
};

export default Layout;
